
import React, { Component } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import styled from 'styled-components';

import { Drawer } from 'ui/Drawer';
import OrderDetail from 'components/Order/Detail';
import TableCellDates from 'components/Order/TableParts/TableCellDates';
import TableCellDescription from 'components/Order/TableParts/TableCellDescription';
import TableCellCargo from 'components/Order/TableParts/TableCellCargo';
import { useOrderDroppable } from './Dnd';


const StyledTableRow = styled(TableRow)`

  &:hover {
    cursor: pointer;
    background: #f8f8f8;
  }
  
  background-color: transparent;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
  
  &.updated {
    background-color: rgba(250,190,10,0.3);
  }

  ${props => props.$isOver && `
    background-color: rgba(254, 193, 8, 0.28) !important;
    outline: 1px dashed #fec108;
  `}
  
  .MuiTableCell-root {
    padding: 6px;
  }
`;

const DropHandleCell = styled(TableCell)`
  width: 28px;
  min-width: 28px !important;
  max-width: 28px;
  padding: 0 !important;
  vertical-align: middle !important;
  color: ${props => props.$isOver ? '#333' : '#bdbdbd'};
  background: ${props => props.$isOver ? 'rgba(254, 193, 8, 0.45)' : 'transparent'};
`;

const StyledTableCellStatus = styled(TableCell)`
  font-size: 12px;
  vertical-align: top;
  padding-top: 8px;
  width: 28%;
  
  .status {
     font-weight: bold;
  }
`;

const Divider = styled.div`
  background: rgba(224, 224, 224, 0.5);
  height: 1px;
  margin: 1px 0;
`;


function DroppableOrderRow({ order, disabled, rowRef, children, ...rowProps }) {
  const { isOver, setNodeRef } = useOrderDroppable(order, disabled);

  return (
    <StyledTableRow
      ref={(node) => {
        setNodeRef(node);
        if (rowRef) {
          rowRef.current = node;
        }
      }}
      $isOver={isOver}
      {...rowProps}
    >
      <DropHandleCell
        $isOver={isOver}
        onClick={(event) => event.stopPropagation()}
        title={'Перетащите свободное ТС сюда'}
      >
        <DragIndicatorIcon fontSize="small" />
      </DropHandleCell>
      {children}
    </StyledTableRow>
  );
}


export default class PlanningListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
      updated: this.props.item.updated
    };

    this.ref = React.createRef();
  }

  isPreviewOpen = () => {
    const { item, previewId } = this.props;
    return previewId !== undefined && String(previewId) === String(item.id);
  };

  openPreview = () => {
    const { item, onPreview } = this.props;
    if (onPreview) {
      onPreview(item);
      return;
    }
    this.setState({ isDrawerOpen: true });
  };

  closePreview = () => {
    const { onClosePreview } = this.props;
    if (onClosePreview) {
      onClosePreview();
      return;
    }
    this.setState({ isDrawerOpen: false });
  };

  componentDidUpdate() {
    const { item } = this.props;
    if (this.state.updated !== item.updated) {
      this.setState({
        updated: item.updated
      });
      if (this.ref.current) {
        this.ref.current.classList.add('updated');
        setTimeout(() => {
          if (this.ref.current) {
            this.ref.current.classList.remove('updated');
          }
        }, 500);
      }
    }
  }

  render() {
    const { item, apiUrl = 'planning', basePath = '/planning', listPath, onPreview, dropDisabled, onClearBinding } = this.props;
    const isDrawerOpen = this.isPreviewOpen() || this.state.isDrawerOpen;
    const fromPath = listPath ? `${listPath}/preview/${item.id}` : undefined;

    let color = '#fff';
    if (isDrawerOpen) {
      color = '#f5005714';
    }
    else if (item.order_status && item.order_status.color) {
      color = item.order_status.color + '33'
    }

    return (
      <React.Fragment>
        <DroppableOrderRow
          order={item}
          disabled={dropDisabled}
          rowRef={this.ref}
          onClick={() => this.openPreview()}
          style={{backgroundColor: color}}
        >
          <StyledTableCellStatus>
            <div className={'status'}>
              {item.order_status ? item.order_status.label : '-'}
            </div>
            <Divider />
            <div
              className={'status'}
              style={{color: item.order_type ? item.order_type.color : undefined}}
            >
              {item.order_type ? (item.order_type.short_name || item.order_type.name) : '-'}
            </div>
          </StyledTableCellStatus>
          <TableCellDates item={item} />
          <TableCellCargo item={item} />
          <TableCellDescription
            item={item}
            onClearBinding={onClearBinding}
            clearDisabled={dropDisabled}
          />
        </DroppableOrderRow>
        {!onPreview && (
          <Drawer
            open={isDrawerOpen}
            onClose={() => this.closePreview()}
            width={'450px'}
            disableEscapeKeyDown={true}
          >
            <OrderDetail
              id={item.id}
              onClose={this.closePreview}
              apiUrl={apiUrl}
              basePath={basePath}
              fromPath={fromPath}
            />
          </Drawer>
        )}
      </React.Fragment>
    )
  }
}
